import { render, staticRenderFns } from "./exodus-holiday-info.vue?vue&type=template&id=09f0386c&scoped=true"
import script from "./exodus-holiday-info.vue?vue&type=script&lang=js"
export * from "./exodus-holiday-info.vue?vue&type=script&lang=js"
import style0 from "./exodus-holiday-info.vue?vue&type=style&index=0&id=09f0386c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f0386c",
  null
  
)

export default component.exports